import React from 'react'
import { Button } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { DownloadOutlined } from '@ant-design/icons'
import styles from './OffsetByExcelButton.module.scss'
import { integrationProjectListSelector } from 'src/features'
import Link from 'next/link'

const OffsetByExcelButton: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const { id: integrationId } = router.query
  const { data: projectsList } = useAppSelector(integrationProjectListSelector)
  const offsetLink = `/developers/offset-by-excel?id=${integrationId}`

  return <Link passHref href={offsetLink}>
    <Button
      type='text'
      className={styles.button}
      icon={<DownloadOutlined />}
      disabled={projectsList.length < 1}
      block
    >
      {t('developers.OffSet.Title')}
    </Button>
  </Link>
}

export default OffsetByExcelButton
